import { LoadDoctor } from 'domain/usecases/doctor/load-doctor'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteLoadDoctor implements LoadDoctor {
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  load(params?: LoadDoctor.Params): Promise<LoadDoctor.Model> {
    return this.doctorRepository.loadDoctor(params)
  }
}

export type LoadDoctorModel = LoadDoctor.Model
